import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { getQuestionType, patchQuestionType, postQuestionType } from "../../api/api_question_type"
import { cleanEntity } from "../../Common/js/clean_entity"
import withHooks from "../../Common/jsx/WithHooks"
import { FR, GB } from "country-flag-icons/react/3x2"

class QuestionTypeForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      shortname: "",
      nameFr: "",
      descriptionFr: "",
      commonStatementFr: "",
      nameEn: "",
      descriptionEn: "",
      commonStatementEn: "",
      exemple: "",
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = true
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      //relations from getRelatedEntities
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
    this.getRelatedEntities()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getQuestionType(this.props.entityId)
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity, isReadyToRender: true })
    }
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    //nothing yet
    // /CONFIG =================================================================================================
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      shortname: Yup.string().required(this.props.t("message.required")),
      nameFr: Yup.string().required(this.props.t("message.required")),
      nameEn: Yup.string().required(this.props.t("message.required")),
    })
    // /CONFIG =================================================================================================
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)

    try {
      // CONFIG ==================================================================================================

      let entity = cleanEntity(values)
      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postQuestionType(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchQuestionType(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        entitiesType: this.props.entitiesType,
      })
      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              {/* {console.log("Formik values:", values)}
              {console.log("Formik errors:", errors)}
              {console.log("Formik touched:", touched)} */}
              <Row>
                <Col md={1}></Col>
                <Col md={10}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={1}></Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.shortname") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formShortname">
                                  <Field as={Form.Control} name="shortname" isInvalid={touched.shortname && errors.shortname} onChange={handleChange} value={values.shortname} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="shortname" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={1}>
                            <FR title="Français" className="lang_flag" />
                          </Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.name") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formNameFr">
                                  <Field as={Form.Control} name="nameFr" isInvalid={touched.nameFr && errors.nameFr} onChange={handleChange} value={values.nameFr} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="nameFr" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.description") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formDescriptionFr">
                                  <Field as={Form.Control} name="descriptionFr" isInvalid={touched.descriptionFr && errors.descriptionFr} onChange={handleChange} value={values.descriptionFr} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="descriptionFr" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.commonStatement") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formCommonStatementFr">
                                  <Field
                                    as={Form.Control}
                                    name="commonStatementFr"
                                    isInvalid={touched.commonStatementFr && errors.commonStatementFr}
                                    onChange={handleChange}
                                    value={values.commonStatementFr}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="commonStatementFr" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={1}>
                            <GB title="English" className="lang_flag" />
                          </Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.name") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formNameEn">
                                  <Field as={Form.Control} name="nameEn" isInvalid={touched.nameEn && errors.nameEn} onChange={handleChange} value={values.nameEn} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="nameEn" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.description") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formDescriptionEn">
                                  <Field as={Form.Control} name="descriptionEn" isInvalid={touched.descriptionEn && errors.descriptionEn} onChange={handleChange} value={values.descriptionEn} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="descriptionEn" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 ">
                                <Form.Label>{this.props.t("form.commonStatement") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formCommonStatementEn">
                                  <Field
                                    as={Form.Control}
                                    name="commonStatementEn"
                                    isInvalid={touched.commonStatementEn && errors.commonStatementEn}
                                    onChange={handleChange}
                                    value={values.commonStatementEn}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="commonStatementEn" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={1}></Col>
                          <Col md={11}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8">
                                <Form.Label>{this.props.t("form.exemple") + this.props.t("app.dbp")}</Form.Label>
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formExemple">
                                  <Field as={Form.Control} name="exemple" isInvalid={touched.exemple && errors.exemple} onChange={handleChange} value={values.exemple} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="exemple" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={4}></Col>
                          <Col md={2} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={2} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(QuestionTypeForm)
